import React, { useState, useEffect } from 'react';
import Popup from '../common/popup/Popup';
import { useCookieConsent } from './CookieConsentContext';
import '../../styles/components/cookies/CookieSettingsModal.css';

const CookieSettingsModal = ({ isOpen, onRequestClose }) => {
  const { consent, updateConsent } = useCookieConsent();
  const [localConsent, setLocalConsent] = useState(consent);

  useEffect(() => {
    setLocalConsent(consent);
  }, [consent]);

  const handleSave = () => {
    updateConsent(localConsent);
    onRequestClose();
  };

  return isOpen ? (
    <Popup
      title="Cookie Settings"
      onCancel={onRequestClose}
      disableOverlayClose={false}
      disableEscapeClose={false}
      footer={
        <>
          <button onClick={handleSave} className="popup-btn confirm-btn">
            Save
          </button>
          <button onClick={onRequestClose} className="popup-btn cancel-btn">
            Cancel
          </button>
        </>
      }
    >
      <div className="cookie-settings-content">
        <p className="cookie-settings-description">
          We use cookies to provide you with a better experience. By accepting all cookies, you agree to our use of cookies to deliver and maintain our services and site, improve the quality of WeiFinders, personalise content and advertising, and measure the effectiveness of advertising. By rejecting non-essential cookies, we may still use certain cookies to ensure the proper functionality of our platform. Your preferences can be changed later. Read more on our{" "}
          <a href="/privacy-policy" className="CookieConsent__link">
            Privacy Policy
          </a>.
        </p>
        <div className="cookie-settings-container">
          <div className="cookie-settings-option">
            <label>
              <input
                type="radio"
                name="cookieConsent"
                value="true"
                checked={localConsent === true}
                onChange={() => setLocalConsent(true)}
              />
              <span>Accept all</span>
            </label>
          </div>
          <div className="cookie-settings-option">
            <label>
              <input
                type="radio"
                name="cookieConsent"
                value="false"
                checked={localConsent === false}
                onChange={() => setLocalConsent(false)}
              />
              <span>Reject non-essential</span>
            </label>
          </div>
        </div>
      </div>
    </Popup>
  ) : null;
};

export default CookieSettingsModal;
